function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M218 105c11-11 11-29 0-40s-29-11-40 0L8 235c-11 11-11 29 0 40l171 172c11 11 29 11 40 0s11-29 0-40L69 255zm75 302c-11 11-11 29 0 40s29 11 40 0l171-172c11-11 11-29 0-40L334 65c-11-11-29-11-40 0s-11 29 0 40l149 150z"
}));